module.exports = __webpack_public_path__ + "img/intro1.8569c92e.png";